export const constructionVisitFeedbackConstants = {
  GET_FEEDBACK_REQUEST: "CONSTRUCTION_VISIT_FEEDBACK_GET_FEEDBACK_REQUEST",
  GET_FEEDBACK_SUCCESS: "CONSTRUCTION_VISIT_FEEDBACK_GET_FEEDBACK_SUCCESS",
  GET_FEEDBACK_FAILURE: "CONSTRUCTION_VISIT_FEEDBACK_GET_FEEDBACK_FAILURE",
  RESET_FEEDBACK: "CONSTRUCTION_VISIT_FEEDBACK_RESET_FEEDBACK"
};
